const TRANSLATION_FILE_VERSION = '6.1';
module.exports = { TRANSLATION_FILE_VERSION };
